<template>
  <!-- Card 86akqwgkw: aulas encontradas pela busca, com o módulo de origem. -->
  <section class="found">
    <p class="found__label">
      {{
        $tc("course.lessonsFound", results.length, { count: results.length })
      }}
    </p>

    <ul v-if="results.length" class="found__list">
      <li
        v-for="item in results"
        :key="`${item.module.id}-${item.lesson.id}`"
        class="found__item"
      >
        <button type="button" class="found__row" @click="$emit('open', item)">
          <span
            class="found__dot"
            :style="{ background: categoryColor(item.lesson.category) }"
            aria-hidden="true"
          ></span>
          <span class="found__body">
            <span class="found__title">{{
              item.lesson.title || $t("course.untitled")
            }}</span>
            <span class="found__meta">
              {{
                $t("course.lessonMeta", {
                  module: item.module.title,
                  position: lessonPosition(item.position),
                  category: categoryLabel(item.lesson.category),
                })
              }}
            </span>
          </span>
          <i class="mdi mdi-arrow-right found__go" aria-hidden="true"></i>
        </button>
      </li>
    </ul>

    <p v-else class="found__empty">
      {{ $t("course.noMatch") }}
    </p>
  </section>
</template>

<script>
import {
  categoryColor,
  categoryLabel,
  lessonPosition,
} from "@/shared/courseTiers";

export default {
  name: "LessonSearchResults",
  props: {
    // [{ module, lesson, position }] -- saída de findLessons()
    results: { type: Array, default: () => [] },
  },
  methods: {
    categoryColor,
    categoryLabel,
    lessonPosition,
  },
};
</script>

<style scoped>
.found {
  margin-bottom: 40px;
  font-family: "Poppins", sans-serif;
}
.found__label {
  margin: 0 0 14px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--dk-faint, #9a96a6);
}
.found__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.found__row {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 18px;
  border: 1px solid var(--dk-line, #eae7f0);
  border-radius: 14px;
  background: var(--dk-surface, #fff);
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.18s ease;
}
.found__row:hover {
  border-color: #d9d2e4;
}
.found__row:focus-visible {
  outline: 3px solid var(--dk-pink, #e8276f);
  outline-offset: 2px;
}
.found__dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex: none;
}
.found__body {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}
.found__title {
  font-size: 14px;
  font-weight: 600;
  color: var(--dk-ink, #211b2e);
}
.found__meta {
  font-size: 12px;
  color: var(--dk-ink-soft, #6e6a79);
}
.found__go {
  font-size: 18px;
  color: var(--dk-faint, #9a96a6);
}
.found__empty {
  margin: 0;
  font-size: 14px;
  color: var(--dk-ink-soft, #6e6a79);
}
</style>
